import { ArrowRight } from "lucide-react";

export default function CTAAgendar() {
  return (
    <section id="cta-moderno" className="bg-brand-accent text-brand-primary" data-testid="section-cta-agendar">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <p className="eyebrow mb-5 text-brand-primary/70"><span className="thin-rule bg-brand-primary/60" />Propósito</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Uma advocacia <em className="not-italic">moderna, relevante</em> e impactante.
          </h2>
          <p className="mt-6 text-[15px] lg:text-base leading-relaxed text-brand-primary/85 max-w-2xl">
            Nosso propósito é transformar conhecimento jurídico em soluções concretas para pessoas e
            empresas.
          </p>
          <p className="mt-4 text-[15px] lg:text-base leading-relaxed text-brand-primary/85 max-w-2xl">
            Com atuação estratégica, técnica e humanizada, buscamos oferecer muito mais do que
            suporte jurídico: entregamos confiança, segurança e direcionamento para decisões
            importantes.
          </p>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <a
            href="#contato"
            data-testid="cta-agendar-button"
            className="group inline-flex items-center gap-3 bg-brand-primary text-brand-accent px-8 py-5 text-[12px] tracking-[0.25em] uppercase font-semibold hover:bg-brand-primary2 transition-colors"
          >
            Agende uma consulta
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
